@if (position !== 'absolute') {
  <ng-container *ngTemplateOutlet="content"></ng-container>
} @else {
  <div *teleportTo="'dropdown'">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>
}

<ng-template #content>
  <div class="dropdown" [ngClass]="{ 'dropdown--active': active }">
    <div
      #dropdownEl
      class="dropdown__main dropdown__main--{{ size }} dropdown__main--{{ align }} dropdown__main--{{ direction }}"
      [ngClass]="{ 'dropdown__main--active': active, 'dropdown__main--absolute': position === 'absolute', 'dropdown__main--hidden': position === 'absolute' && !left }"
      [ngStyle]="{ 'width.px': width(), 'top.px': top(), 'left.px': left() }"
    >
      <div class="dropdown__main-head">
        <button class="dropdown__main-close" type="button" (click)="close()">
          <app-icon [icon]="'close'" [height]="24"></app-icon>
        </button>
        <app-title [tag]="'h6'">{{ title }}</app-title>
      </div>
      <div class="dropdown__main-content">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</ng-template>
